module.exports = __webpack_public_path__ + "static/offer-business-2-b9493c959ddabb4129a9d5f293de96ab.png";